<template>
  <div class="big-box" id="gallery">
    <span class="title">Gallery Kegiatan PO Fasilkom</span>
    <div class="gallery-item" v-for="item in gallery" :key="item.id">
      <div class="gallery-image-section">
        <img
          :src="'https://po.cs.ui.ac.id/media/' + item.coverPhoto"
          class="cover-photo"
          alt=""
        />
      </div>
      <div class="gallery-text">
        <h3 class="gallery-title sub-title">{{ item.title }}</h3>
        <h4 class="gallery-date body">{{ convertDate(item.date) }}</h4>
        <div class="gallery-content body-txt" v-html="excerpt(item.content)" />
        <router-link v-bind:to="'/gallery/' + item.id">
          <span class="body-txt">Read More...</span>
        </router-link>
      </div>
    </div>
    <div class="gallery-pagination">
      <div class="gallery-pagination-newer">
        <router-link v-if="hasPrev" v-bind:to="'?p=' + currentPage">
          <span v-on:click="currentPage -= 1">
            See newer post
          </span>
        </router-link>
      </div>
      <div class="gallery-pagination-current">
        Page {{ currentPage }} of {{ totalPage }}
      </div>
      <div class="gallery-pagination-older">
        <router-link v-if="hasNext" v-bind:to="'?p=' + currentPage">
          <span v-on:click="currentPage += 1">
            See older post
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { convertDate, excerpt } from "../utils/index";
import { constant } from "../const";

export default {
  name: "Gallery",
  data() {
    return {
      gallery: [],
      prevPage: null,
      currentPage: null,
      totalPage: null,
      hasPrev: null,
      hasNext: null
    };
  },
  mounted() {
    this.load();
  },
  beforeUpdate() {
    if (
      this.prevPage &&
      this.currentPage &&
      this.prevPage != this.currentPage
    ) {
      this.load();
    }
  },
  methods: {
    load() {
      var page = 1;
      if (this.currentPage == null) {
        if (this.$route.query.p) {
          page = this.$route.query.p;
        }
      } else {
        page = this.currentPage;
      }

      axios
        .post(constant.apiUrl, {
          query: `{
              pagedActivities(page: ${page}){
                page
                pages
                hasNext
                hasPrev
                objects {
                  id
                  title
                  date
                  coverPhoto
                  content
                }
              }
            }`
        })
        .then(res => {
          var data = res.data.data.pagedActivities;
          this.gallery = data.objects;
          this.prevPage = data.page;
          this.currentPage = data.page;
          this.totalPage = data.pages;
          this.hasPrev = data.hasPrev;
          this.hasNext = data.hasNext;
        })
        .catch(err => {
          console.log(err);
        });
    },
    convertDate,
    excerpt
  }
};
</script>

<style scoped>
#gallery {
  background-color: #f1f1f1;
  min-height: 80vh;
  justify-content: flex-start;
  margin-top: 7vh;
  padding: 10vh 5vw 10vh;
  display: flex;
  flex-direction: column;
  width: calc(100% - 10vw);
}

.gallery-item {
  background-color: #d6e5ed;
  width: auto;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 4vh 0px;
  padding: 4vh 30px;
}

.gallery-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.cover-photo {
  width: 26vw;
  height: auto;
  border-radius: 5px;
  margin: 0 2vw;
}

.gallery-title {
  margin-bottom: 5px;
  text-align: left;
}

.gallery-date {
  margin: 0px 0px 5px;
}

.gallery-content {
  margin-top: 0px;
  text-align: left;
}

.body-txt {
  font-size: 18px;
}

.gallery-pagination {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
}

.gallery-pagination * {
  flex: 1 1 0px;
}

.gallery-pagination-newer {
  text-align: left;
}

.gallery-pagination-older {
  text-align: right;
}

@media only screen and (max-width: 900px) {
  .gallery-item {
    flex-direction: column;
  }
  .gallery-text {
    width: 100%;
  }

  .cover-photo {
    width: 32vw;
  }
}

@media screen and (max-width: 600px) {
  .body-txt {
    font-size: 14px;
  }

  .gallery-content {
    display: none;
  }

  .cover-photo {
    width: 60vw;
    margin: 0;
  }

  .gallery-item {
    align-items: flex-start;
    padding: 2vh 5vw;
  }

  .gallery-title {
    margin-top: 0;
  }
}

@media screen and (max-width: 375px) {
  #gallery {
    padding-top: 13vh;
  }
}
</style>
